import React from 'react';
import PropTypes from 'prop-types';
import FieldGroup from './FieldGroup';
import Form from './Form';
import AvailableLanguagesField from './AvailableLanguagesField';

export default class MultilingualForm extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    languages: PropTypes.arrayOf(PropTypes.object).isRequired,
    onLanguageChange: PropTypes.func,
    activeLanguage: PropTypes.string
  };

  constructor(props){
    super(props);
    this.state = {
      activeLanguage: this.props.activeLanguage || 'en'
    }
  }

  componentWillReceiveProps(newProps){
    if(newProps.errorMessage){
      this.setState({ isDisabled: false });
    }
  }

  onLanguageChange = (language) => {
    if(this.props.onLanguageChange) {
      this.props.onLanguageChange(language);
    }
    this.setState({
      activeLanguage: Object.keys(language)[0].toLowerCase()
    })
  }

  render() {
    return (
      <Form {...this.props} activeLanguage={this.state.activeLanguage} >
        <FieldGroup className="container-fluid">
          <FieldGroup className="form-setup-translate row">
            <FieldGroup className="col-9">
              {this.props.children}
            </FieldGroup>
            <FieldGroup className="col-3">
              <AvailableLanguagesField languages={this.props.languages} onLanguageChange={this.onLanguageChange} />
            </FieldGroup>
          </FieldGroup>
        </FieldGroup>
      </Form>
    );
  }
}
